import { shallowEqual } from 'react-redux';
import { DetailedIconEmail } from '@zillow/constellation';

import { useSelector } from '../../../selectors/useSelector';

import ScreeningPreferencesTextButton from '../../ScreeningPreferencesTextButton';

import { StyledEmptyIconContainer, StyledEmptyStateContainer } from '../../../StyledComponents';
import { EmptyStateBodyText, EmptyStateTitleText, StyledEmptySimpleCard } from '../../../styles';

const NoInterestedRenters = () => {
  const {
    isEnabled: isScreeningCriteriaEnabled,
    isSet: isScreeningCriteriaSet,
    dateLastActivatedTimestamp,
  } = useSelector((state) => {
    return {
      listingAlias: state.properties.propertyOverview.listingAlias,
      isEnabled: state.properties.propertyOverview.screeningCriteria.isEnabled,
      isSet: state.properties.propertyOverview.screeningCriteria.isSet,
      dateLastActivatedTimestamp: state.properties.currentProperty.dateLastActivatedTimestamp,
    };
  }, shallowEqual);

  const showScreeningCriteriaCTA = isScreeningCriteriaEnabled && dateLastActivatedTimestamp !== '';

  // Setting screening criteria could help attract more renters to your property.
  // Adjusting your criteria could help attract more renters to your property.

  const bodyPrefix = isScreeningCriteriaSet ? 'Adjusting your' : 'Setting screening';
  const screeningCriteriaBody = `${bodyPrefix} criteria could help attract more renters to your property.`;

  return (
    <StyledEmptySimpleCard data-testid="EmptyInterestedRentersCard">
      <StyledEmptyStateContainer>
        <StyledEmptyIconContainer>
          <DetailedIconEmail />
        </StyledEmptyIconContainer>

        <EmptyStateTitleText asChild>
          <h4>No leads yet</h4>
        </EmptyStateTitleText>

        {showScreeningCriteriaCTA && (
          <EmptyStateBodyText asChild>
            <p>{screeningCriteriaBody}</p>
          </EmptyStateBodyText>
        )}

        <ScreeningPreferencesTextButton textStyle="body-bold" />
      </StyledEmptyStateContainer>
    </StyledEmptySimpleCard>
  );
};

export default NoInterestedRenters;
